export default __webpack_public_path__ + "static/media/tommy.3e5f7fb7.png";